import { MstSyozokuApi } from "@/api/MstSyozokuApi";
import { BaseOptionWithoutCode } from "@/types/Option";
import { Syozoku } from "@/types/Syozoku";

export class MstSyozokuService {

  /**
   * 全ての所属会社の部課を取得します（オプション値）
   */
  public async getAll(): Promise<Syozoku[]> {
    const api = new MstSyozokuApi();
    try {
      return await api.getAll();
    } catch (e) {
      throw e;
    }
  }

  /**
   * 全ての所属会社の部課を取得します（オプション値）
   */
  public async getAllOptions(): Promise<BaseOptionWithoutCode[]> {
    const api = new MstSyozokuApi();
    try {
      return await api.getAllOptions();
    } catch (e) {
      throw e;
    }
  }

}
